import { Component, input } from '@angular/core';
import { ImageEnum } from '../../utils/image.enum';

@Component({
  selector: 'app-desktop-required',
  imports: [],
  templateUrl: './desktop-required.html',
})
export class DesktopRequiredComponent {
  protected readonly imageEnum = ImageEnum;
  readonly isTablet = input(false);
  readonly isSmallScreen = input(false);
  /** Shown over a running exam: the tablet was turned to portrait mid-exam. */
  readonly duringExam = input(false);
}
